var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 131.375 130.191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.943,
    y1: 0.375,
    x2: 0.186,
    y2: 0.738,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55f267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16a933"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star",
    d: "M96.3,35.458a5.125,5.125,0,0,0-4.413-3.524L64.017,29.4,53,3.614a5.134,5.134,0,0,0-9.443,0L32.543,29.4,4.666,31.934a5.138,5.138,0,0,0-2.917,8.979l21.07,18.475L16.607,86.75A5.131,5.131,0,0,0,24.243,92.3L48.278,77.928,72.308,92.3a5.136,5.136,0,0,0,7.641-5.549L73.737,59.389l21.07-18.475a5.138,5.138,0,0,0,1.5-5.455ZM48.741,77.65",
    transform: "matrix(0.839, -0.545, 0.545, 0.839, -0.27, 52.172)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.e0d6feaa5560df2312be4db413d4c6fd.svg";
export { ForwardRef as ReactComponent };